// Number formatting helpers shared by the charts and metric boxes.

// numbro's mantissa is a fixed number of decimals, which loses every meaningful
// digit of a value far below 1: a ROAS of 0.007 rendered with two decimals reads
// '0.01', and 0.00007 reads '0'. This keeps `baseMantissa` significant decimals
// instead — the count grows with the leading zeros (0.5 -> 2, 0.045 -> 3,
// 0.00123 -> 4), and values of 1 or more keep the fixed count they always had.
// Pair it with numbro's optionalMantissa/trimMantissa so the extra room never
// shows up as trailing zeros.
const MAX_MANTISSA = 10

export function significantMantissa (value, baseMantissa = 2) {
  const magnitude = Math.abs(Number(value))
  if (!isFinite(magnitude) || magnitude === 0 || magnitude >= 1) return baseMantissa
  return Math.min(MAX_MANTISSA, baseMantissa - 1 - Math.floor(Math.log10(magnitude)))
}
